import Flag from '../Flag';

/** Last Close flag */
export default class LastCloseFlag extends Flag {
	_getStyle(args = {}) {
		const returnStyle = this.core.getStyle('flag.lastClose');
		const panelStyle = this.panel.params.style;

		// Use fallback values if necessary
		if (!returnStyle.font.family) returnStyle.font.family = panelStyle.yAxis.font.family;
		if (!returnStyle.font.size) returnStyle.font.size = panelStyle.yAxis.font.size;

		return {
			...returnStyle,
			...args.style
		};
	}

	/**
	 * Private method to get flag value
	 * @return {number}
	 * @override
	 * @private
	 */
	getValue() {
		if (!this.core.data) return null;

		const data = this.core.data[this.indicator.params.symbol];
		let symbolData = this.getFirstDataset(data ? data.price || [] : []);
		let key = 'close';
		let val = null;

		// Check for custom data.  Custom data will live in a slightly different place.
		if (this.core.params.customData) {
			symbolData = this.core.data[this.indicator.params.datasetId];
			if (symbolData?.length > 0 && 'value' in symbolData[0]) {
				key = 'value'; // use "value" over "close" if it's available
			}
		}

		if (symbolData?.length) {
			for (const row of [...symbolData].reverse()) {
				val = row[key];

				if (typeof val === 'number') {
					val = val.toFixed(4);
					break;
				}
			}
		}
		return +val;
	}

	/**
	 * Gets the first available data set for this symbol
	 * @param {object} data Symbol data
	 * @private
	 */
	getFirstDataset(data) {
		for (const x in data) {
			if (Object.prototype.hasOwnProperty.call(data, x)) return data[x];
		}
		return null;
	}

	/**
	 * @returns The appropriate event emitter types
	 * @type {object}
	 */
	get eventType() {
		return {
			render: 'FLAG_RENDER_LASTCLOSE',
			hide: 'FLAG_HIDE_LASTCLOSE',
			show: 'FLAG_SHOW_LASTCLOSE'
		};
	}

	render() {
		// Only render flag if enabled
		if (this.core.params.showLastCloseFlags) return super.render();
	}
}
